"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeItemCancelSignatureRequestedEventDataSchema = exports.changeItemSignedProposalSentEventDataSchema = exports.changeItemSignatureSubmittedEventDataSchema = exports.changeItemSignatureRequestedEventDataSchema = exports.changeItemProposalSubmittedEventDataSchema = exports.changeItemProposalUpdateRequestedEventDataSchema = exports.changeItemProposalRequestedEventDataSchema = exports.changeItemWorkflowActionExternalFileDownloadedEventDataSchema = exports.changeItemReopenedEventDataSchema = exports.changeItemWorkflowActionFileDownloadedEventDataSchema = exports.changeItemModifiedEventDataSchema = exports.changeItemClosedEventDataSchema = exports.changeItemSentEventDataSchema = exports.changeItemReviewResponseEventDataSchema = exports.changeItemForwardedEventDataSchema = exports.changeItemReceivedEventDataSchema = exports.changeItemReceivedPendingEventDataSchema = exports.changeItemCreatedEventDataSchema = exports.changeItemBaseEventDataSchema = void 0;
const zod_1 = require("zod");
const subjectField_schema_1 = require("../../../common/schemas/subjectField.schema");
const shortField_schema_1 = require("../../../common/schemas/shortField.schema");
const contactDetails_schema_1 = require("../../../common/schemas/contactDetails.schema");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const selectedItemWithName_schema_1 = require("../../../common/schemas/selectedItemWithName.schema");
const ChangeItemType_1 = require("../../types/ChangeItemType");
const longField_schema_1 = require("../../../common/schemas/longField.schema");
const attachmentFile_schema_1 = require("../attachmentFile.schema");
const change_schema_1 = require("../../../common/schemas/change.schema");
const ChangeItemStatus_1 = require("../../types/ChangeItemStatus");
const Purpose_1 = require("../../types/Purpose");
const ReceivedVia_1 = require("../../types/ReceivedVia");
const eventData_schema_1 = require("../../../common/schemas/eventData.schema");
const amountWithCurrency_schema_1 = require("../common/amountWithCurrency.schema");
const Response_1 = require("../../types/Response");
const onlyInReviewPurposeNotExcluded = [Purpose_1.Purpose.ForInformationOnly, Purpose_1.Purpose.ForConstruction];
exports.changeItemBaseEventDataSchema = zod_1.z
    .object({
    workflowActionId: zod_1.z.string(),
    status: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemStatus_1.ChangeItemStatus),
    changeItemType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemType_1.ChangeItemType),
    files: attachmentFile_schema_1.attachmentFileSchema.array().optional(),
})
    .strict();
exports.changeItemCreatedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    subject: subjectField_schema_1.subjectFieldSchema,
    number: shortField_schema_1.shortFieldSchema,
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema.array().nonempty(),
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, onlyInReviewPurposeNotExcluded),
    description: longField_schema_1.longFieldSchema.optional(),
    reasons: selectedItemWithName_schema_1.selectedItemWithNameSchema.array().optional(),
    disciplines: selectedItemWithName_schema_1.selectedItemWithNameSchema.array().optional(),
    keywords: selectedItemWithName_schema_1.selectedItemWithNameSchema.array().optional(),
    dueDate: datetime_schema_1.datetimeSchema.optional(),
    proposedTotalAmount: amountWithCurrency_schema_1.amountWithCurrencySchema.optional(),
    proposedTotalDays: zod_1.z.number().nonnegative().int().optional(),
    senderNumber: shortField_schema_1.shortFieldSchema.optional(),
})
    .strict();
exports.changeItemReceivedPendingEventDataSchema = exports.changeItemCreatedEventDataSchema;
exports.changeItemReceivedEventDataSchema = exports.changeItemCreatedEventDataSchema
    .extend({
    receivedDate: datetime_schema_1.datetimeSchema,
    receivedVia: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ReceivedVia_1.ReceivedVia),
})
    .strict();
exports.changeItemForwardedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    to: contactDetails_schema_1.contactDetailsSchema.array().nonempty(),
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, onlyInReviewPurposeNotExcluded),
    reviewDueDate: datetime_schema_1.datetimeSchema.optional(),
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.changeItemReviewResponseEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    action: selectedItemWithName_schema_1.selectedItemWithNameSchema,
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema.array().nonempty(),
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    response: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.changeItemSentEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema.array().nonempty(),
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [Purpose_1.Purpose.ForReview]),
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.changeItemClosedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    action: selectedItemWithName_schema_1.selectedItemWithNameSchema,
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.changeItemModifiedEventDataSchema = zod_1.z
    .object({
    changeItemType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemType_1.ChangeItemType),
    subject: (0, change_schema_1.changeSchema)(subjectField_schema_1.subjectFieldSchema).optional(),
    description: (0, change_schema_1.changeSchema)(longField_schema_1.longFieldSchema).optional(),
    reopenedDate: (0, change_schema_1.changeSchema)(datetime_schema_1.datetimeSchema).optional(),
    dueDate: (0, change_schema_1.changeSchema)(datetime_schema_1.datetimeSchema).optional(),
    number: (0, change_schema_1.changeSchema)(shortField_schema_1.shortFieldSchema).optional(),
    reasons: (0, change_schema_1.changeSchema)(selectedItemWithName_schema_1.selectedItemWithNameSchema.array()).optional(),
    disciplines: (0, change_schema_1.changeSchema)(selectedItemWithName_schema_1.selectedItemWithNameSchema.array()).optional(),
    receivedVia: (0, change_schema_1.changeSchema)((0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ReceivedVia_1.ReceivedVia)).optional(),
    keywords: (0, change_schema_1.changeSchema)(selectedItemWithName_schema_1.selectedItemWithNameSchema.array()).optional(),
    receivedDate: (0, change_schema_1.changeSchema)(datetime_schema_1.datetimeSchema).optional(),
    senderNumber: (0, change_schema_1.changeSchema)(shortField_schema_1.shortFieldSchema.nullable()).optional(),
    proposedTotalAmount: (0, change_schema_1.changeSchema)(amountWithCurrency_schema_1.amountWithCurrencySchema.nullable()).optional(),
    proposedTotalDays: (0, change_schema_1.changeSchema)(zod_1.z.number().nonnegative().int().nullable()).optional(),
})
    .strict();
exports.changeItemWorkflowActionFileDownloadedEventDataSchema = eventData_schema_1.workflowActionFileDownloadedEventDataSchema
    .extend({
    changeItemType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemType_1.ChangeItemType),
})
    .strict();
exports.changeItemReopenedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema.array().nonempty(),
    reopenedDate: datetime_schema_1.datetimeSchema,
    remarks: longField_schema_1.longFieldSchema.optional(),
    dueDate: datetime_schema_1.datetimeSchema.optional(),
})
    .strict();
exports.changeItemWorkflowActionExternalFileDownloadedEventDataSchema = zod_1.z
    .object({
    changeItemType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemType_1.ChangeItemType),
    workflowActionId: zod_1.z.string(),
    fileName: zod_1.z.string(),
})
    .strict();
exports.changeItemProposalRequestedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [Purpose_1.Purpose.ForReview]),
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema,
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.changeItemProposalUpdateRequestedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [Purpose_1.Purpose.ForReview]),
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema,
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.changeItemProposalSubmittedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema.array().nonempty(),
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
    proposedTotalAmount: amountWithCurrency_schema_1.amountWithCurrencySchema.optional(),
    proposedTotalDays: zod_1.z.number().nonnegative().int().optional(),
    receivedVia: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ReceivedVia_1.ReceivedVia).optional(),
    receivedDate: datetime_schema_1.datetimeSchema.optional(),
    contractorSenderNumber: shortField_schema_1.shortFieldSchema.optional(),
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [
        Purpose_1.Purpose.ForReview,
        Purpose_1.Purpose.ForConstruction,
        Purpose_1.Purpose.ForInformationOnly,
    ]),
})
    .strict();
exports.changeItemSignatureRequestedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    files: attachmentFile_schema_1.attachmentFileSchema.array().nonempty(),
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema,
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.changeItemSignatureSubmittedEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    response: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Response_1.Response, [
        Response_1.Response.Approved,
        Response_1.Response.ReviewedAsNoted,
        Response_1.Response.NoExceptions,
        Response_1.Response.NoActionTaken,
        Response_1.Response.Reviewed,
        Response_1.Response.Void,
    ]),
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema,
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.changeItemSignedProposalSentEventDataSchema = exports.changeItemBaseEventDataSchema
    .extend({
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema.array().nonempty(),
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [
        Purpose_1.Purpose.ForReview,
        Purpose_1.Purpose.ForConstruction,
        Purpose_1.Purpose.ForUpdatedQuote,
        Purpose_1.Purpose.NewQuote,
    ]),
    files: attachmentFile_schema_1.attachmentFileSchema.array().nonempty(),
})
    .strict();
exports.changeItemCancelSignatureRequestedEventDataSchema = exports.changeItemBaseEventDataSchema
    .omit({ files: true })
    .extend({
    from: contactDetails_schema_1.contactDetailsSchema,
    to: contactDetails_schema_1.contactDetailsSchema,
    cc: contactDetails_schema_1.contactDetailsSchema.array().optional(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
//# sourceMappingURL=eventData.schema.js.map